<template>
  <div class="left-content">
    <!-- <img class="bg-img" :src="detailData.image | imageUrl('/static/specialCompetitiom/speCombj.png')"/> -->
    <div class="special-content">
      <div v-html="richText(detailData.introduction)" class="aaa"></div>
    </div>
  </div>
</template>

<script>
import { richText } from "../../../util/filters.js";

export default {
  metaInfo () {
      return {
        title: this.$t('global.竞赛介绍') + " | MANA"
      }
  },
  data() {
    return {
      detailData: {},
      category: ["", this.$t('global.线上活动'), this.$t('global.线下活动'), this.$t('global.竞赛')],
      type: ""
    };
  },
  watch: {
    $route: function() {
      let currentID = this.$route.params.id;
      if (currentID == this.detailData.id) return;
      this.getData(this.$route.params.id);
    }
  },
  methods: {
    getData(activityId) {
      this.$http
        .get("/api/activity/detail", {
          params: {
            activityId: activityId
          }
        })
        .then(data => {
          let d = data.data;
          let detailData = {};
          detailData.id = d.id;
          detailData.title = d.title;
          detailData.type = d.category;
          detailData.image = d.images;
          detailData.introduction = d.introduction;
          this.detailData = detailData;
          this.type = this.category[d.category];
        });
    },
    richText
  },
  created() {
    this.getData(this.$route.params.id);
    this.buriedPoint(30,this.$route.params.id)
  }
};
</script>

<style lang="stylus" scoped>
  .special-content >>> p{
    overflow:hidden;
  }
.special-content >>> img {
  max-width:100%;
}

.left-content {
  width: 677px;
  padding: 40px;
  background-color: #ffffff;

  .title {
    color: #333333;
    font-size: 0.39rem;
    font-weight: bold;
  }

  .type {
    color: #777777;
    font-size: 0.18rem;
    margin-top: 0.12rem;
  }

  .bg-img {
    display: block;
    margin-top: 0.39rem;
    width: 10.8rem;
    height: 6.12rem;
    background: url('/static/specialCompetitiom/speCombj.png') no-repeat;
    background-size: cover;
  }

  .special-content {
    color: #333333;
    font-size: 0.16rem;

    p {
      margin-top: 0.36rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/match/Detail.vue